import { createMap, datalayers, isArrayEmpty, isObject, LoaderContext } from "../omnia"
import { IDataLayer, IDataLayerValue, LayerTypeId } from "../types"

export function loadSoilTextureLayers(layers: IDataLayer[], context: LoaderContext) {

    const soilTextureLayers = layers.filter(l => (l.TypeId === LayerTypeId.SoilType) && (!isArrayEmpty(l.Zones)))

    for (const layer of soilTextureLayers) {
        loadSoilTextureLayer(layer, context)
    }

    return layers

}

function loadSoilTextureLayer(layer: IDataLayer, context: LoaderContext) {

    const profile = getProfile(layer, context)

    if (!profile) {
        return
    }

    const values: IDataLayerValue[] = profile.Classes.map(p => ({
        Value: p.Id,
        Name: p.Name,
        Style: {
            Colour: p.Color
        }
    }))

    const map = createMap(values, v => v.Value)

    layer.SupportedValues = values

    for (const zone of layer.Zones) {

        const id = isObject(zone.Value)
            ? (zone.Value as IDataLayerValue).Value
            : zone.Value

        const c = id ? map.get(Number(id)) : undefined

        zone.Value = c ?? zone.Value
    }

}


function getProfile(layer: IDataLayer, context: LoaderContext) {

    const customStyleId = layer.CustomTypeId

    if (customStyleId) {

        const customStyle = context.customStyles.find(s => (s.CustomStyleId === customStyleId) && (s.TypeId === LayerTypeId.SoilType))

        const profile = customStyle?.SoilTextureProfile

        if (profile) {
            return profile
        }

    }

    return layer.Properties?.SoilTextureProfile

}
